<template>
    <div>
        <template>
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> Blacklist Companies ({{active_count}})</h1>
                <div class="searching float-right mr-2">
                    <input id="search_active" type="text" placeholder="Search" class="form-control search" name="" />
                </div>
            </div>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
                    <table id="companyTable" class="table">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Company Name</th>
                                <th>User Name</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Address</th>
                                <th>Nacta Match</th>
                                <th>Nacta Score</th>
                                <th>Ofac Match</th>
                                <th>Ofac Score</th>
                                <th>Unsc Match</th>
                                <th>Unsc Score</th>
                                <th class="text-center">Action</th>
                            </tr>
                        </thead>
                    </table>
                </div>

                
            </div>
        </template>

    </div>
</template>

<script>
    var gThat = null;
    export default {
        data() {
            return {
                data : null,
                dtActive : null,
                active_count : 0,
            };
        },
        mounted() {
            gThat = this;
            this.blacklistCompanies();
        },
        methods: {
            blacklistCompanies(){
                this.dtActive = $('#companyTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/blacklistCompanies",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": 'records',
                        "data": function ( d ) {
                            d.tab = 'active';
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'company_name'},
                        {data: 'user_name'},
                        {data: 'user_cnic'},
                        {data: 'email'},
                        {data: 'mobile_no'},
                        {data: 'nacta_match'},
                        {data: 'nacta_score'},
                        {data: 'ofac_match'},
                        {data: 'ofac_score'},
                        {data: 'unsc_match'},
                        {data: 'unsc_score'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            return '<a href="javascript:void(0);" onclick="VueComponents.blacklistCompaniesComponent.methods.deleteCompany('+full['id']+')">Whitelist</a>';
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 11 ]
                    }],
                    "initComplete": (settings, json) => { this.active_count = json.recordsTotal; this.$Progress.finish();}
                });
                $('#search_active').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        gThat.dtActive.search(this.value).draw();
                    }
                });
            },
           deleteCompany(id){
               var that = this;
               gThat.$Progress.start();
               swal.fire({
                    title: 'Are you sure?',
                    text: "You want to Whitelist this company !",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Whitelist it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get("/api/whitelistCompany/"+id)
                        .then(res => {
                            if(res.status == 200){
                                if(res.data.status == 200){
                                    gThat.$Progress.finish();
                                    gThat.dtActive.ajax.reload( json => {
                                        gThat.active_count = json.recordsTotal;
                                    }, false);
                                    gThat.showAlertBox('success','Company Whitelisted successfully.');
                                }else{
                                    gThat.showToastBox('error','System is not responding! Please try again later.');
                                }
                            }else{
                                gThat.$Progress.fail();
                                gThat.showAlertBox('error','System is not responding! Please try again later.');
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            gThat.$Progress.fail();
                            gThat.showAlertBox('error','System is not responding! Please try again later.');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        gThat.$Progress.finish();
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                });
                
           },
        },
    }
</script>
